import { useEffect, useState } from "react";
import type { JSX } from "react/jsx-runtime";
import Dropdown, { type DropdownFilter } from "../Dropdown/Dropdown";

const FILTERS_RADIUS = [
  { value: 0, name: "Ganzer Ort" },
  { value: 5, name: "+ 5 km" },
  { value: 10, name: "+ 10 km" },
  { value: 20, name: "+ 20 km" },
  { value: 30, name: "+ 30 km" },
  { value: 50, name: "+ 50 km" },
  { value: 100, name: "+ 100 km" },
  { value: 150, name: "+ 150 km" },
  { value: 200, name: "+ 200 km" },
];

type Props = {
  initialRadius: number;
  onFormSubmit: () => void;
  disabled: boolean;
};

function RadiusSelection({
  initialRadius,
  onFormSubmit,
  disabled,
}: Props): JSX.Element {
  const [shouldSubmit, setShouldSubmit] = useState(false);
  const [radius, setRadius] = useState(initialRadius);

  const selectedRadius =
    FILTERS_RADIUS.find((filter) => filter.value === radius) ??
    FILTERS_RADIUS[0];

  useEffect(() => {
    if (shouldSubmit) {
      onFormSubmit();
      setShouldSubmit(false);
    }
  }, [shouldSubmit, onFormSubmit]);

  function handleFilterSelect(filter: DropdownFilter): void {
    setRadius(filter.value);
    setShouldSubmit(true);
  }

  return (
    <>
      <Dropdown
        filters={FILTERS_RADIUS}
        onFilterSelect={handleFilterSelect}
        listId="radius-dropdown-list"
        label="Radius auswählen"
        defaultFilter={selectedRadius.name}
        disabled={disabled}
      />
      <input
        name="radius"
        type="hidden"
        className="hidden"
        defaultValue={radius}
      />
    </>
  );
}

export default RadiusSelection;
